import React, { useState, useCallback, useEffect, useMemo } from "react";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import useDeptDashboard from "../hooks/useDeptDashboard";

import MainLayout from "../components/layout/MainLayout";

import AgendaSection from "../components/ui/AgendaSection";

import PointageModule from "../components/shared/PointageModule";
import GenerationCodeModule from "../components/shared/GenerationCodeModule"; // eslint-disable-line no-unused-vars
import MarquerFinJournee from "../components/MarquerFinJournee";

import PersonnelManagementModule from "../components/shared/PersonnelManagementModule";

import AlertesPanel from "../components/shared/AlertesPanel";

import { JournalCaisseRH, PerformanceModule, ProcesVerbauxRH } from "../components/rh"; // eslint-disable-line no-unused-vars
import MaPerformance from "../components/rh/MaPerformance";
import ComptabiliteModule from "../components/comptabilite/ComptabiliteModule"; // eslint-disable-line no-unused-vars
import PaieModuleFonctionnel from "../components/comptabilite/PaieModuleFonctionnel";

import ObjectifsEquipePanel from "../components/shared/ObjectifsEquipePanel"; // eslint-disable-line no-unused-vars

import { TaskManagementModule } from "../components/rh";
import PreuvesPanel from "../components/shared/PreuvesPanel";

import TaskToggleWithPreuve from "../components/shared/TaskToggleWithPreuve";
import PersonalTaskModal from "../components/shared/PersonalTaskModal"; // eslint-disable-line no-unused-vars
import ObjectifsEmployesModule from "../components/shared/ObjectifsEmployesModule";
import MesDemandesPermission from "../components/employe/MesDemandesPermission";

import CRMModule from "../components/projets/CRMModule"; // eslint-disable-line no-unused-vars

import api from "../services/api";

import "./DashboardDGPage.css";
import { useMobileSidebar } from "../hooks/useMobileSidebar";

// eslint-disable-next-line no-unused-vars
const CRITERES_LABELS = [
  "Ponctualité",
  "Accompliss.",
  "Objectifs",
  "Qualité",
  "Initiative",
  "Equipe",
];

// eslint-disable-next-line no-unused-vars
const CRITERES_KEYS = [
  "ponctualite",
  "accomplissement",
  "objectifs",
  "qualite",
  "initiative",
  "equipe",
];

// D?partement Administration & RH ? adapter l'ID selon ta BDD

const DEPT_ID = 22; // Caisse ? Administration & RH (FHC Conseil)

function Pbar({ pct, color }) {
  const c =
    color || (pct >= 70 ? "#4caf50" : pct >= 40 ? "#ff9800" : "#ef5350");

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div className="pbar-wrap" style={{ flex: 1 }}>
        <div
          className="pbar-fill"
          style={{ width: `${pct}%`, background: c }}
        />
      </div>

      <span
        style={{ fontSize: 10, color: "#778", width: 28, textAlign: "right" }}
      >
        {pct}%
      </span>
    </div>
  );
}

function ScoreChip({ score }) {
  const c = score >= 8 ? "#66bb6a" : score >= 6 ? "#C9A84C" : "#ef8080";

  return (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        border: `2px solid ${c}`,
        background: c + "15",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Cormorant Garamond,serif",
        fontSize: 16,
        fontWeight: 600,
        color: c,
      }}
    >
      {score}
    </div>
  );
}

function PtCell({ s }) {
  const map = {
    ok: ["#66bb6a", "?"],
    retard: ["#ffb74d", "?"],
    absent: ["#ef8080", "?"],
  };

  const [c, icon] = map[s] || ["#334", "?"];

  return <span style={{ color: c, fontSize: 12 }}>{icon}</span>;
}

function ModalWrap({ title, onSave, onClose, children }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.75)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#162535",
          border: "1px solid rgba(255,255,255,.12)",
          borderRadius: 14,
          padding: 28,
          minWidth: 420,
          maxWidth: 520,
          width: "90%",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 20,
          }}
        >
          <span style={{ fontSize: 15, fontWeight: 600, color: "#fff" }}>
            {title}
          </span>

          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#889",
              fontSize: 22,
              cursor: "pointer",
            }}
          >
            ?
          </button>
        </div>

        {children}

        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
            marginTop: 20,
          }}
        >
          <button className="btn-outline" onClick={onClose}>
            Annuler
          </button>
          <button className="btn-gold" onClick={onSave}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}

export default function DashboardRHPage() {
  const navigate = useNavigate();
  useMobileSidebar();

  const { logout: authLogout, user } = useAuth();

  const [activePage, setActivePage] = useState("vue-globale");

  const [modal, setModal] = useState(null);

  const [form, setForm] = useState({});

  const [detailEmp, setDetailEmp] = useState(null);

  const [projets, setProjets] = useState([]);

  // États pour la modal de tâches personnelles
  const [showPersonalTaskModal, setShowPersonalTaskModal] = useState(false); // eslint-disable-line no-unused-vars
  const [editingTask, setEditingTask] = useState(null); // eslint-disable-line no-unused-vars

  useEffect(() => {
    api.projects
      .getAll({ departement_id: DEPT_ID })

      .then((res) => setProjets(res.projects || []))

      .catch(() => {});
  }, []);

  const {
    employes,
    setEmployes,

    tasks,
    setTasks,

    loading,
    error,
    refetch,

    toggleTask,
    deleteTask,
    createTask,
    updateTask,
  } = useDeptDashboard({ deptId: DEPT_ID });

  const openModal = useCallback((type, data = {}) => {
    setForm(data);
    setModal(type);
  }, []);

  const closeModal = useCallback(() => {
    setModal(null);
    setForm({});
  }, []);

  const handleLogout = async () => {
    await authLogout();
    navigate("/auth", { replace: true });
  };
  const handleOpenTaskModal = (task = null) => {
    if (task) {
      setEditingTask(task);
      setForm({
        _id: task.id,
        text: task.text,
        prio: task.prio || "normale",
        description: task.description || "",
      });
    } else {
      setEditingTask(null);
      setForm({ text: "", prio: "normale", description: "" });
    }
    setShowPersonalTaskModal(true);
  };

  const presents = employes.filter((e) => e.present).length;

  const retards = employes.filter(
    (e) =>
      e.present &&
      e.arrivee &&
      e.arrivee !== "?" &&
      e.arrivee > (e.heureLimite || "08:30"),
  ).length;

  const scoreAvg =
    employes.length > 0
      ? (
          employes.reduce((s, e) => s + (e.score || 0), 0) / employes.length
        ).toFixed(1)
      : "0";

  const allObj = employes.flatMap((e) => e.objectifs || []);

  const objRate =
    allObj.length > 0
      ? Math.round(
          (allObj.filter((o) => o.statut === "atteint").length /
            allObj.length) *
            100,
        )
      : 0;

  const accompAvg =
    employes.filter((e) => e.tachesQuot > 0).length > 0
      ? Math.round(
          employes
            .filter((e) => e.tachesQuot > 0)
            .reduce(
              (s, e) => s + Math.round((e.tachesDone / e.tachesQuot) * 100),
              0,
            ) / employes.filter((e) => e.tachesQuot > 0).length,
        )
      : 0;

  const pendingTasks = tasks.filter((t) => !t.done).length; // eslint-disable-line no-unused-vars

  const totalTasks = employes.reduce(
    (sum, emp) => sum + (emp.assignedTasks || []).length,
    0,
  );

  // 🔹 Filtrer les t?ches du chef connect? pour "Mes t?ches"

  const myTasks = useMemo(() => {
    const userId = user?.id;

    if (!userId) return tasks; // Fallback: afficher toutes si pas d'user

    return tasks.filter((t) => t.employee_id === userId);
  }, [tasks, user]);

  const myPendingTasks = myTasks.filter((t) => !t.done).length;

  const saveEmploye = async () => {
    if (!form.prenom || !form.nom) {
      alert("Veuillez remplir tous les champs obligatoires");

      return;
    }

    console.log("🔹 Sauvegarde de l'employ? - Form data:", form);

    try {
      if (form._isEdit && form.id) {
        // Mise ? jour via l'API

        const employeeData = {
          prenom: form.prenom,

          nom: form.nom,

          poste: form.poste || "?",

          departement_id: DEPT_ID,

          filiale: form.filiale || "?",

          contrat: form.contrat || "CDI",

          heure_limite: form.heureLimite || "08:30",

          score_performance: parseFloat(form.score) || 0,

          color: form.color || "#42a5f5",
        };

        console.log("🔹 Donn?es envoy?es ? l'API (update):", employeeData);

        const response = await api.employeesCRUD.update(form.id, employeeData);

        console.log("? R?ponse API (update employ?):", response);

        setEmployes((prev) =>
          prev.map((e) =>
            e.id === form.id
              ? {
                  ...e,

                  prenom: form.prenom,

                  nom: form.nom,

                  av: (
                    (form.prenom[0] || "") + (form.nom[0] || "")
                  ).toUpperCase(),

                  poste: form.poste || "?",

                  filiale: form.filiale || "?",

                  color: form.color || e.color,

                  contrat: form.contrat || "CDI",

                  heureLimite: form.heureLimite || "08:30",

                  score: parseFloat(form.score) || 0,
                }
              : e,
          ),
        );
      } else {
        // Cr?ation - Utiliser le nouvel endpoint

        const employeeData = {
          prenom: form.prenom,

          nom: form.nom,

          poste: form.poste || "?",

          departement_id: DEPT_ID,

          contrat: form.contrat || "CDI",

          heure_limite: form.heureLimite || "08:30",

          score_performance: parseFloat(form.score) || 0,

          color: form.color || "#42a5f5",

          email: form.email || null,

          password: form.password || null,
        };

        console.log("🔹 Données envoyées à l'API (create):", employeeData);

        const response =
          await api.completeResources.createEmployeeWithUser(employeeData);

        console.log("? Réponse API (create employé):", response);

        if (response.success) {
          const newEmp = response.employee;

          const user = newEmp.user || {};

          const newEmploye = {
            id: newEmp.id,

            av: ((user.prenom[0] || "") + (user.nom[0] || "")).toUpperCase(),

            prenom: user.prenom,

            nom: user.nom,

            poste: user.poste,

            dept: "Administration & RH",

            filiale: form.filiale || "?",

            color: newEmp.color || "#42a5f5",

            contrat: newEmp.contrat || "CDI",

            entree: new Date().toLocaleDateString("fr-FR", {
              month: "long",
              year: "numeric",
            }),

            heureLimite: newEmp.heure_limite || "08:30",

            arrivee: "?",

            present: false,

            score: newEmp.score_performance || 0,

            scoreLabel: "Nouveau",

            tachesQuot: 0,

            tachesDone: 0,

            pointage: [],

            criteres: {},

            objectifs: [],

            pendingTasks: [],

            assignedTasks: [],
          };

          setEmployes((prev) => [...prev, newEmploye]);

          if (response.credentials) {
            alert(
              `? Employé créé avec succès!\n\nIdentifiants de connexion:\nEmail: ${response.credentials.email}\nMot de passe: ${response.credentials.password}\n\n🔹 ${response.credentials.note}`,
            );
          }
        }
      }

      closeModal();
    } catch (error) {
      console.error("? Erreur lors de la sauvegarde:", error);

      alert(
        "Erreur lors de la sauvegarde: " + (error.message || "Erreur inconnue"),
      );
    }
  };

  const saveTask = async () => {
    if (!form.text) {
      alert("Veuillez saisir l'intitulé de la tâche");

      return;
    }

    try {
      const taskData = {
        titre: form.text,

        priority: form.prio || "normale",

        category: "RH",

        departement_id: DEPT_ID,
      };

      if (form._id) {
        await updateTask(form._id, taskData);
      } else {
        await createTask(taskData);
      }

      closeModal();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde de la tâche:", error);

      if (form._id) {
        setTasks((prev) =>
          prev.map((t) =>
            t.id === form._id
              ? { ...t, text: form.text, prio: form.prio || "normale" }
              : t,
          ),
        );
      } else {
        setTasks((prev) => [
          ...prev,
          {
            id: Date.now(),

            text: form.text,

            done: false,

            prio: form.prio || "normale",

            date: new Date().toISOString().slice(0, 10),
          },
        ]);
      }

      closeModal();

      alert("Tâche sauvegardée localement (erreur de connexion au serveur)");
    }
  };

  const F = ({ label, name, type = "text", opts, required }) => {
    const handleChange = (e) => {
      setForm((prev) => ({ ...prev, [name]: e.target.value }));
    };

    return (
      <div style={{ marginBottom: 12 }}>
        <label
          style={{
            fontSize: 10,
            color: "#667",
            textTransform: "uppercase",
            letterSpacing: ".8px",
            display: "block",
            marginBottom: 5,
          }}
        >
          {label} {required && <span style={{ color: "#ef8080" }}>*</span>}
        </label>

        {opts ? (
          <select
            style={{
              width: "100%",
              background: "#0d1b2a",
              border: "1px solid rgba(255,255,255,.15)",
              borderRadius: 8,
              padding: "9px 12px",
              color: "#fff",
              fontFamily: "inherit",
              fontSize: 13,
              outline: "none",
            }}
            value={form[name] || ""}
            onChange={handleChange}
          >
            <option value="">-- choisir --</option>

            {opts.map((o) => (
              <option key={o} value={o} style={{ background: "#0d1b2a" }}>
                {o}
              </option>
            ))}
          </select>
        ) : (
          <input
            style={{
              width: "100%",
              background: "rgba(255,255,255,.05)",
              border: "1px solid rgba(255,255,255,.07)",
              borderRadius: 8,
              padding: "9px 12px",
              color: "#fff",
              fontFamily: "inherit",
              fontSize: 13,
              outline: "none",
            }}
            type={type}
            value={form[name] || ""}
            onChange={handleChange}
            autoFocus={required && !form[name]}
          />
        )}
      </div>
    );
  };

  return (
    <MainLayout>
      <div className="dashboard-dg-root">
        {/* TOPBAR */}

        <div className="topbar">
          <div className="topbar-left">
            <div
              className="tlogo"
              style={{ background: "linear-gradient(135deg,#42a5f5,#1565c0)" }}
            >
              🔹
            </div>

            <div>
              <div className="tname">FHC Groupe SARL</div>

              <div className="tsub">Dashboard  Chef Administration & RH</div>
            </div>
          </div>

          <div className="topbar-right">
            <div className="tdate">
              {new Date().toLocaleDateString("fr-FR", {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </div>

            <button className="tbtn" onClick={refetch}>
              ?
            </button>

            <div style={{ textAlign: "right" }}>
              <div className="tuser">Chef RH</div>

              <div className="trole" style={{ color: "#64b5f6" }}>
                🔹 Administration & RH
              </div>
            </div>

            <div
              className="tavatar"
              style={{ background: "linear-gradient(135deg,#42a5f5,#1565c0)" }}
            >
              RH
            </div>

            <button
              className="tbtn"
              onClick={handleLogout}
              style={{ color: "#ef8080", borderColor: "rgba(239,83,80,.3)" }}
            >
              🔹 Déconnexion
            </button>
          </div>
        </div>

        {/* LAYOUT */}

        <div className="layout">
          {/* SIDEBAR */}

          <div className="sidebar">
            <div className="sb-logo">RH & Personnel</div>

            {[
              { id: "vue-globale", icon: "🔹", label: "Vue globale" },

              {
                id: "personnel",
                icon: "🔹",
                label: "Personnel",
                badge: String(employes.length),
                badgeCls: "green",
              },

              {
                id: "mon-equipe",
                icon: "🔹",
                label: "Mon équipe",
                badge: String(employes.length),
                badgeCls: "green",
              },

              {
                id: "gestion-taches",
                icon: "🔹",
                label: "Gestion Tâches",
                badge: totalTasks > 0 ? String(totalTasks) : "",
                badgeCls: "gold",
              },

              // { id: "presence", icon: "🔹", label: "Présence & Pointage" },

              { id: "ma-performance", icon: "⭐", label: "Ma Performance" },


              { id: "objectifs", icon: "🔹", label: "Objectifs" },

              {
                id: "projets",
                icon: "🔹",
                label: "Projets",
                badge: projets.length > 0 ? String(projets.length) : "",
              },

              { id: "contrats", icon: "🔹", label: "Contrats & Dossiers" },

              { id: "paie", icon: "💰", label: "Gestion de Paie" },

              { id: "agenda", icon: "🔹", label: "Agenda RH" },
              // { id: "journal-caisse", icon: "🔹", label: "Journal de Caisse" },
              // { id: "proces-verbaux", icon: "📋", label: "Procès-Verbaux" },

              // { id: "crm", icon: "🔹", label: "CRM" },

              { id: "permissions", icon: "📝", label: "Mes Permissions" },

              {
                id: "alertes",
                icon: "🔹",
                label: "Alertes",
                badge: String(
                  employes.filter((e) => !e.present || e.score < 6).length,
                ),
              },
            ].map((it) => (
              <div
                key={it.id}
                className={`sb-item ${activePage === it.id ? "active" : ""}`}
                onClick={() => setActivePage(it.id)}
              >
                <span className="si">{it.icon}</span>
                <span>{it.label}</span>

                {it.badge && (
                  <span className={`sb-badge ${it.badgeCls || ""}`}>
                    {it.badge}
                  </span>
                )}
              </div>
            ))}

            <div className="sb-sep" />

            <div className="sb-logo">Mes tâches</div>

            <div
              className={`sb-item ${activePage === "mes-taches" ? "active" : ""}`}
              onClick={() => setActivePage("mes-taches")}
            >
              <span className="si">?</span>
              <span>Mes Tâches</span>

              {myPendingTasks > 0 && (
                <span className="sb-badge">{myPendingTasks}</span>
              )}
            </div>

            <div className="sb-sep" />

            <div className="sb-item" onClick={() => navigate('/documents')}>
              <span className="si">📁</span><span>Documents</span>
            </div>
          </div>

          {/* MAIN */}

          <div className="main">
            {loading && (
              <div
                style={{
                  padding: 40,
                  textAlign: "center",
                  color: "#C9A84C",
                  fontSize: 14,
                }}
              >
                Chargement des données RH
              </div>
            )}

            {error && !loading && (
              <div
                style={{
                  margin: "12px 16px",
                  padding: "10px 14px",
                  background: "rgba(239,83,80,.1)",
                  border: "1px solid rgba(239,83,80,.3)",
                  borderRadius: 8,
                  fontSize: 12,
                  color: "#ef8080",
                }}
              >
                🔹 {error}
              </div>
            )}

            {/* VUE GLOBALE */}

            <div
              className={`page ${activePage === "vue-globale" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">
                    Vue Globale  Administration & RH
                  </div>
                  <div className="page-sub">
                    Données temps réel  {employes.length} collaborateurs
                  </div>
                </div>

                <button
                  className="btn-gold"
                  onClick={() =>
                    openModal("employe", {
                      contrat: "CDI",
                      heureLimite: "08:30",
                      color: "#42a5f5",
                    })
                  }
                >
                  + Créer un compte
                </button>
              </div>

              <PointageModule currentUser={{ nom: "Chef RH" }} />

              <MarquerFinJournee onSuccess={() => {
                console.log('Fin de journée enregistrée - Dashboard RH');
              }} />

              <div
                className="kpi-grid"
                style={{ gridTemplateColumns: "repeat(6,1fr)" }}
              >
                {[
                  {
                    icon: "🔹",
                    val: employes.length,
                    label: "Collaborateurs",
                    color: "#42a5f5",
                  },

                  {
                    icon: "?",
                    val: presents,
                    label: "Présents",
                    color: "#4caf50",
                  },

                  {
                    icon: "?",
                    val: retards,
                    label: "Retards",
                    color: "#ff9800",
                  },

                  {
                    icon: "🔹",
                    val: accompAvg + "%",
                    label: "Taux accomplissement",
                    color: "#C9A84C",
                  },

                  {
                    icon: "?",
                    val: scoreAvg,
                    label: "Score moyen /10",
                    color: "#ab47bc",
                  },

                  {
                    icon: "🔹",
                    val: objRate + "%",
                    label: "Objectifs atteints",
                    color: "#26c6da",
                  },
                ].map((k) => (
                  <div key={k.label} className="kpi-card">
                    <div
                      className="kpi-accent"
                      style={{ background: k.color }}
                    />

                    <div className="kpi-icon">{k.icon}</div>

                    <div className="kpi-val" style={{ color: k.color }}>
                      {k.val}
                    </div>

                    <div className="kpi-label">{k.label}</div>
                  </div>
                ))}
              </div>

              <div className="card">
                <div className="card-title">
                  🔹 Tableau du personnel
                  <button
                    className="btn-outline"
                    style={{ fontSize: 11, padding: "3px 10px" }}
                    onClick={() => setActivePage("mon-equipe")}
                  >
                    Voir tout 
                  </button>
                </div>

                {employes.length === 0 ? (
                  <div
                    style={{
                      padding: "20px 0",
                      textAlign: "center",
                      color: "#445",
                      fontSize: 12,
                    }}
                  >
                    Aucun collaborateur dans ce département.
                  </div>
                ) : (
                  <table className="tbl">
                    <thead>
                      <tr>
                        <th>Collaborateur</th>
                        <th>Poste</th>
                        <th>Filiale</th>
                        <th>Présence</th>
                        <th>Score</th>
                        <th>Tâches</th>
                      </tr>
                    </thead>

                    <tbody>
                      {employes.map((e) => {
                        const pct =
                          e.tachesQuot > 0
                            ? Math.round((e.tachesDone / e.tachesQuot) * 100)
                            : 0;

                        return (
                          <tr
                            key={e.id}
                            style={{ cursor: "pointer" }}
                            onClick={() => setDetailEmp(e)}
                          >
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <div
                                  style={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: "50%",
                                    background: e.color + "22",
                                    color: e.color,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 10,
                                    fontWeight: 700,
                                  }}
                                >
                                  {e.av}
                                </div>
                                <span className="bold">
                                  {e.prenom} {e.nom}
                                </span>
                              </div>
                            </td>

                            <td>{e.poste}</td>

                            <td>{e.filiale}</td>

                            <td>
                              {e.present ? (
                                <span className="badge green">? Présent</span>
                              ) : (
                                <span className="badge red">? Absent</span>
                              )}
                            </td>

                            <td>
                              <ScoreChip score={e.score} />
                            </td>

                            <td style={{ minWidth: 100 }}>
                              <Pbar pct={pct} />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>

              <div className="grid2">
                <div className="card">
                  <div className="card-title">🔹 Performance par filiale</div>

                  {[...new Set(employes.map((e) => e.filiale))].map((f) => {
                    const emps = employes.filter((e) => e.filiale === f);

                    const avg = (
                      emps.reduce((s, e) => s + e.score, 0) / emps.length
                    ).toFixed(1);

                    const pct = Math.round(
                      emps
                        .filter((e) => e.tachesQuot > 0)
                        .reduce(
                          (s, e) =>
                            s + Math.round((e.tachesDone / e.tachesQuot) * 100),
                          0,
                        ) / (emps.filter((e) => e.tachesQuot > 0).length || 1),
                    );

                    return (
                      <div
                        key={f}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          padding: "8px 0",
                          borderBottom: "1px solid rgba(255,255,255,.04)",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: 11,
                              fontWeight: 500,
                              color: "#fff",
                            }}
                          >
                            {f}
                          </div>
                          <div style={{ fontSize: 9, color: "#556" }}>
                            {emps.length} employé(s)
                          </div>
                        </div>

                        <div style={{ textAlign: "center", width: 50 }}>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 600,
                              color: pct >= 70 ? "#66bb6a" : "#ff9800",
                            }}
                          >
                            {pct}%
                          </div>
                          <div style={{ fontSize: 8, color: "#445" }}>
                            tâches
                          </div>
                        </div>

                        <div style={{ textAlign: "center", width: 40 }}>
                          <div
                            style={{
                              fontSize: 13,
                              fontWeight: 600,
                              color:
                                parseFloat(avg) >= 8 ? "#66bb6a" : "#C9A84C",
                            }}
                          >
                            {avg}
                          </div>
                          <div style={{ fontSize: 8, color: "#445" }}>/10</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="card">
                  {/* Alertes - Connect? au backend */}

                  <AlertesPanel departementId={DEPT_ID} limit={6} />
                </div>
              </div>
            </div>

            {/* PERSONNEL */}

            <div
              className={`page ${activePage === "personnel" ? "active" : ""}`}
            >
              <PersonnelManagementModule
                employes={employes}
                setEmployes={setEmployes}
                departmentName="Administration & RH"
                heureLimite="08:30"
              />
            </div>

            {/* MON ?QUIPE */}

            <div
              className={`page ${activePage === "mon-equipe" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Mon équipe</div>
                  <div className="page-sub">
                    {employes.length} collaborateurs
                  </div>
                </div>

                <button
                  className="btn-gold"
                  onClick={() =>
                    openModal("employe", {
                      contrat: "CDI",
                      heureLimite: "08:30",
                      color: "#42a5f5",
                    })
                  }
                >
                  + Créer un compte
                </button>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))",
                  gap: 14,
                }}
              >
                {employes.map((e) => {
                  const pct =
                    e.tachesQuot > 0
                      ? Math.round((e.tachesDone / e.tachesQuot) * 100)
                      : 0;

                  return (
                    <div
                      key={e.id}
                      onClick={() => setDetailEmp(e)}
                      style={{
                        background: "#162535",
                        border: "1px solid rgba(255,255,255,.07)",
                        borderRadius: 14,
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          padding: "16px 16px 10px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 3,
                            background: `linear-gradient(90deg,${e.color},transparent)`,
                          }}
                        />

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              width: 44,
                              height: 44,
                              borderRadius: "50%",
                              background: e.color + "22",
                              color: e.color,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 16,
                              fontWeight: 700,
                              border: `2px solid ${e.color}44`,
                            }}
                          >
                            {e.av}
                          </div>

                          <div style={{ textAlign: "right" }}>
                            <div
                              style={{
                                fontSize: 10,
                                color: e.present ? "#66bb6a" : "#ef5350",
                                fontWeight: 600,
                              }}
                            >
                              {e.present ? "? Présent" : "? Absent"}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#fff",
                            marginTop: 8,
                          }}
                        >
                          {e.prenom} {e.nom}
                        </div>

                        <div
                          style={{
                            fontSize: 11,
                            color: "#556",
                            marginBottom: 6,
                          }}
                        >
                          {e.poste}
                        </div>

                        <span
                          style={{
                            fontSize: 9,
                            padding: "2px 8px",
                            borderRadius: 99,
                            background: e.color + "22",
                            color: e.color,
                            fontWeight: 600,
                          }}
                        >
                          {e.dept}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          borderTop: "1px solid rgba(255,255,255,.05)",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px 8px",
                            textAlign: "center",
                            borderRight: "1px solid rgba(255,255,255,.04)",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "Cormorant Garamond,serif",
                              fontSize: 18,
                              fontWeight: 600,
                              color: pct >= 70 ? "#66bb6a" : "#ff9800",
                            }}
                          >
                            {pct}%
                          </div>

                          <div style={{ fontSize: 9, color: "#445" }}>
                            Tâches
                          </div>
                        </div>

                        <div
                          style={{
                            padding: "10px 8px",
                            textAlign: "center",
                            borderRight: "1px solid rgba(255,255,255,.04)",
                          }}
                        >
                          <div style={{ fontSize: 11, color: "#667" }}>
                            {e.contrat}
                          </div>

                          <div style={{ fontSize: 9, color: "#445" }}>
                            Contrat
                          </div>
                        </div>

                        <div
                          style={{
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ScoreChip score={e.score} />
                        </div>
                      </div>

                      <div
                        style={{ padding: "8px 12px", display: "flex", gap: 6 }}
                        onClick={(ev) => ev.stopPropagation()}
                      >
                        <button
                          className="btn-gold"
                          style={{ flex: 1, fontSize: 10, padding: "5px 0" }}
                          onClick={() => setDetailEmp(e)}
                        >
                          Détail 
                        </button>

                        <button
                          className="btn-outline"
                          style={{ fontSize: 10, padding: "5px 8px" }}
                          onClick={() =>
                            openModal("employe", { ...e, _isEdit: true })
                          }
                        >
                          🔹
                        </button>

                        <button
                          className="btn-outline"
                          style={{
                            fontSize: 10,
                            padding: "5px 8px",
                            color: "#ef5350",
                          }}
                          onClick={() =>
                            setEmployes((prev) =>
                              prev.filter((x) => x.id !== e.id),
                            )
                          }
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* GESTION T?CHES */}

            <div
              className={`page ${activePage === "gestion-taches" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Gestion des Tâches</div>
                  <div className="page-sub">
                    {totalTasks} t?che{totalTasks !== 1 ? "s" : ""} assignée
                    {totalTasks !== 1 ? "s" : ""}
                  </div>
                </div>
              </div>

              <PreuvesPanel tasks={tasks} employes={employes} />
              <TaskManagementModule
                employes={employes}
                setEmployes={setEmployes}
              />
            </div>

            {/* 
              SECTIONS DÉPLACÉES VERS DASHBOARD CAISSE :
              - Journal de Caisse
              - Procès-Verbaux
              - CRM
              - Présence & Pointage
            */}

            {/* MA PERFORMANCE */}

            <div
              className={`page ${activePage === "ma-performance" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">⭐ Ma Performance</div>
                  <div className="page-sub">Consultez votre performance personnelle</div>
                </div>
              </div>

              <MaPerformance />
            </div>

            {/* PERFORMANCE */}

            <div
              className={`page ${activePage === "performance" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">📊 Performance & Scores</div>
                  <div className="page-sub">Calcul automatique et saisie manuelle par le DG</div>
                </div>
              </div>

              <PerformanceModule />
            </div>

            {/* OBJECTIFS */}

            <div
              className={`page ${activePage === "objectifs" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">🎯 Objectifs de l'équipe</div>
                  <div className="page-sub">
                    Suivi par collaborateur · Cocher les objectifs atteints
                  </div>
                </div>
              </div>

              <ObjectifsEmployesModule
                employes={employes}
                onRefresh={refetch}
                isChef={true}
              />
            </div>

            {/* CONTRATS */}

            {/* PROJETS */}

            <div className={`page ${activePage === "projets" ? "active" : ""}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Projets du département</div>

                  <div className="page-sub">
                    {projets.length} projet{projets.length !== 1 ? "s" : ""}{" "}
                    assigné{projets.length !== 1 ? "s" : ""}
                  </div>
                </div>
              </div>

              {projets.length === 0 ? (
                <div
                  className="card"
                  style={{ textAlign: "center", padding: 40, color: "#445" }}
                >
                  Aucun projet assigné à ce département.
                </div>
              ) : (
                projets.map((p) => {
                  const sc =
                    {
                      en_cours: "#42a5f5",
                      planification: "#C9A84C",
                      production: "#ff9800",
                      termine: "#66bb6a",
                      annule: "#ef5350",
                      negociation: "#ab47bc",
                    }[p.status] || "#888";

                  const sl =
                    {
                      en_cours: "En cours",
                      planification: "Planification",
                      production: "Production",
                      termine: "Terminé",
                      annule: "Annulé",
                      negociation: "Négociation",
                    }[p.status] || p.status;

                  const av = p.progress || 0;

                  return (
                    <div
                      key={p.id}
                      className="card"
                      style={{ marginBottom: 12 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: 12,
                        }}
                      >
                        <div>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: "#fff",
                              marginBottom: 4,
                            }}
                          >
                            {p.name}
                          </div>

                          <div style={{ fontSize: 11, color: "#667" }}>
                            {p.filiale?.nom || "?"}
                            {p.departement?.nom
                              ? " ? " + p.departement.nom
                              : ""}
                          </div>
                        </div>

                        <span
                          style={{
                            fontSize: 10,
                            fontWeight: 600,
                            padding: "3px 10px",
                            borderRadius: 99,
                            background: sc + "22",
                            color: sc,
                          }}
                        >
                          {sl}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          gap: 10,
                          marginBottom: 12,
                        }}
                      >
                        {[
                          [
                            "Budget",
                            p.budget
                              ? Number(p.budget).toLocaleString("fr-FR") +
                                " FCFA"
                              : "?",
                          ],
                          [
                            "Deadline",
                            p.end_date
                              ? new Date(p.end_date).toLocaleDateString("fr-FR")
                              : "?",
                          ],
                          [
                            "Chef de projet",
                            p.owner
                              ? p.owner.prenom + " " + (p.owner.nom || "")
                              : "?",
                          ],
                        ].map(([l, v]) => (
                          <div
                            key={l}
                            style={{
                              background: "rgba(255,255,255,.04)",
                              borderRadius: 8,
                              padding: "8px 10px",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 9,
                                color: "#556",
                                marginBottom: 3,
                              }}
                            >
                              {l}
                            </div>

                            <div
                              style={{
                                fontSize: 11,
                                fontWeight: 600,
                                color: "#ccc",
                              }}
                            >
                              {v}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 10,
                            color: "#667",
                            marginBottom: 5,
                          }}
                        >
                          <span>Avancement</span>

                          <span
                            style={{
                              fontWeight: 600,
                              color:
                                av >= 70
                                  ? "#66bb6a"
                                  : av >= 40
                                    ? "#ff9800"
                                    : "#ef5350",
                            }}
                          >
                            {av}%
                          </span>
                        </div>

                        <Pbar pct={av} />
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            <div
              className={`page ${activePage === "contrats" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Contrats & Dossiers RH</div>
                  <div className="page-sub">
                    {employes.length} collaborateurs actifs
                  </div>
                </div>
              </div>

              <div className="kpi-grid">
                {[
                  {
                    icon: "🔹",
                    val: employes.filter((e) => e.contrat === "CDI").length,
                    label: "CDI",
                    color: "#C9A84C",
                  },

                  {
                    icon: "🔹",
                    val: employes.filter((e) => e.contrat === "CDD").length,
                    label: "CDD",
                    color: "#42a5f5",
                  },

                  {
                    icon: "🔹",
                    val: employes.filter((e) => e.contrat === "Stage").length,
                    label: "Stages",
                    color: "#ab47bc",
                  },

                  {
                    icon: "?",
                    val: employes.length,
                    label: "Total actifs",
                    color: "#4caf50",
                  },
                ].map((k) => (
                  <div key={k.label} className="kpi-card">
                    <div
                      className="kpi-accent"
                      style={{ background: k.color }}
                    />
                    <div className="kpi-icon">{k.icon}</div>
                    <div className="kpi-val" style={{ color: k.color }}>
                      {k.val}
                    </div>
                    <div className="kpi-label">{k.label}</div>
                  </div>
                ))}
              </div>

              <div className="card">
                <table className="tbl">
                  <thead>
                    <tr>
                      <th>Collaborateur</th>
                      <th>Poste</th>
                      <th>Type</th>
                      <th>Date entrée</th>
                      <th>Avantages</th>
                      <th>Statut</th>
                    </tr>
                  </thead>

                  <tbody>
                    {employes.map((e) => (
                      <tr key={e.id}>
                        <td className="bold">
                          {e.prenom} {e.nom}
                        </td>

                        <td>{e.poste}</td>

                        <td>
                          <span
                            className={`badge ${e.contrat === "CDI" ? "gold" : e.contrat === "Stage" ? "purple" : "blue"}`}
                          >
                            {e.contrat}
                          </span>
                        </td>

                        <td>{e.entree}</td>

                        <td style={{ fontSize: 10, color: "#667" }}>
                          {e.contrat === "CDI"
                            ? "Transport + Prime + CNSS"
                            : e.contrat === "CDD"
                              ? "Transport + CNSS"
                              : "Indemnité + Formation"}
                        </td>

                        <td>
                          <span className="badge green">Actif</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* PAIE */}

            <div className={`page ${activePage === "paie" ? "active" : ""}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">💰 Gestion de Paie</div>
                  <div className="page-sub">Bulletins de salaire et calculs de paie</div>
                </div>
              </div>

              <PaieModuleFonctionnel readOnly={false} />
            </div>

            {/* AGENDA */}

            <div className={`page ${activePage === "agenda" ? "active" : ""}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Agenda RH</div>
                  <div className="page-sub">Entretiens ? Réunions ? PV</div>
                </div>
              </div>

              <AgendaSection
                filterTypes={[
                  "equipe",
                  "codir",
                  "formation",
                  "urgente",
                  "autre",
                  "suivi",
                ]}
              />
            </div>

            {/* PERMISSIONS */}

            <div className={`page ${activePage === "permissions" ? "active" : ""}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">📝 Mes Demandes de Permission</div>
                  <div className="page-sub">Gérez vos demandes de congés, absences et permissions</div>
                </div>
              </div>
              <MesDemandesPermission />
            </div>

            {/* ALERTES */}

            <div className={`page ${activePage === "alertes" ? "active" : ""}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">🔹 Alertes RH</div>
                </div>

                <button className="btn-outline"> Tout marquer lu</button>
              </div>

              <div className="card">
                <div className="card-title">🔹 Alertes critiques</div>

                {employes.filter((e) => !e.present || e.score < 6).length ===
                0 ? (
                  <div
                    style={{
                      padding: 20,
                      textAlign: "center",
                      color: "#66bb6a",
                      fontSize: 12,
                    }}
                  >
                     Aucune alerte critique
                  </div>
                ) : (
                  employes
                    .filter((e) => !e.present || e.score < 6)
                    .map((e) => (
                      <div
                        key={e.id}
                        style={{
                          display: "flex",
                          gap: 10,
                          padding: "10px 0",
                          borderBottom: "1px solid rgba(255,255,255,.04)",
                        }}
                      >
                        <div
                          style={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            background: "#ef5350",
                            flexShrink: 0,
                            marginTop: 3,
                          }}
                        />

                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: 12,
                              color: "#ccc",
                              fontWeight: 500,
                            }}
                          >
                            {e.prenom} {e.nom}
                          </div>

                          <div
                            style={{
                              fontSize: 10,
                              color: "#667",
                              marginTop: 2,
                            }}
                          >
                            {!e.present && "Absent(e) aujourd'hui  "}

                            {e.score < 6 && `Score faible : ${e.score}/10`}

                            {(e.objectifs || []).some(
                              (o) => o.statut === "retard",
                            ) && " ? Objectifs en retard"}
                          </div>
                        </div>

                        <span className="badge red">
                          {!e.present ? "ABSENCE" : "PERFORMANCE"}
                        </span>
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* MES T?CHES */}

            <div
              className={`page ${activePage === "mes-taches" ? "active" : ""}`}
            >
              <div className="page-header">
                <div>
                  <div className="page-title"> Mes Tâches</div>
                  <div className="page-sub">{myPendingTasks} en attente</div>
                </div>

                <button
                  className="btn-gold"
                  onClick={() => handleOpenTaskModal()}
                >
                  + Ajouter
                </button>
              </div>

              <div className="card">
                {myTasks.length === 0 ? (
                  <div
                    style={{
                      padding: "20px 0",
                      textAlign: "center",
                      color: "#445",
                      fontSize: 12,
                    }}
                  >
                    Aucune tâche.
                  </div>
                ) : (
                  myTasks.map((t) => (
                    <div
                      key={t.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "10px 0",
                        borderBottom: "1px solid rgba(255,255,255,.04)",
                      }}
                    >
                      <TaskToggleWithPreuve
                        task={t}
                        onToggle={toggleTask}
                        onToggleWithPreuve={async (id, desc) => {
                          await toggleTask(id);
                        }}
                      />

                      <span
                        style={{
                          flex: 1,
                          fontSize: 13,
                          color: t.done ? "#445" : "#ccc",
                          textDecoration: t.done ? "line-through" : "none",
                        }}
                      >
                        {t.text}
                      </span>

                      <span
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          padding: "2px 7px",
                          borderRadius: 99,
                          background:
                            t.prio === "urgente"
                              ? "rgba(239,83,80,.15)"
                              : t.prio === "haute"
                                ? "rgba(255,152,0,.15)"
                                : "rgba(66,165,245,.15)",
                          color:
                            t.prio === "urgente"
                              ? "#ef8080"
                              : t.prio === "haute"
                                ? "#ffb74d"
                                : "#64b5f6",
                          textTransform: "uppercase",
                        }}
                      >
                        {t.prio}
                      </span>

                      <button
                        style={{
                          background: "none",
                          border: "none",
                          color: "#667",
                          cursor: "pointer",
                          fontSize: 13,
                        }}
                        onClick={() => handleOpenTaskModal(t)}
                      >
                        🔹
                      </button>

                      <button
                        style={{
                          background: "none",
                          border: "none",
                          color: "#ef5350",
                          cursor: "pointer",
                          fontSize: 13,
                        }}
                        onClick={() => deleteTask(t.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          {/* /main */}
        </div>
        {/* /layout */}

        {/* MODALS */}

        {modal === "employe" && (
          <ModalWrap
            title={
              form._isEdit ? "Modifier le collaborateur" : "🔹 Créer un compte"
            }
            onSave={saveEmploye}
            onClose={closeModal}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              <F label="Prénom *" name="prenom" required />

              <F label="Nom *" name="nom" required />
            </div>

            <F label="Poste" name="poste" />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              <F label="Email" name="email" type="email" />

              <F label="Mot de passe" name="password" type="password" />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              <F
                label="Contrat"
                name="contrat"
                opts={["CDI", "CDD", "Stage"]}
              />

              <F label="Heure limite" name="heureLimite" type="time" />
            </div>
          </ModalWrap>
        )}

        {modal === "tache" && (
          <ModalWrap
            title={form._id ? "Modifier la tâche" : "Nouvelle tâche"}
            onSave={saveTask}
            onClose={closeModal}
          >
            <F label="Tâche *" name="text" required />
            <F label="Description" name="description" type="textarea" />

            <F label="Tâche *" name="text" required />

            <F
              label="Priorité"
              name="prio"
              opts={["urgente", "haute", "normale"]}
            />
          </ModalWrap>
        )}

        {/* DETAIL EMPLOY? */}

        {detailEmp && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,.6)",
              zIndex: 900,
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => setDetailEmp(null)}
          >
            <div
              style={{
                width: 440,
                height: "100vh",
                background: "#0d1b2a",
                borderLeft: "1px solid rgba(255,255,255,.1)",
                overflowY: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#0d1b2a",
                  borderBottom: "1px solid rgba(255,255,255,.07)",
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: detailEmp.color,
                  }}
                >
                  {detailEmp.prenom} {detailEmp.nom}
                </span>

                <button
                  onClick={() => setDetailEmp(null)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#667",
                    fontSize: 18,
                    cursor: "pointer",
                  }}
                >
                  ?
                </button>
              </div>

              <div style={{ padding: "18px 18px 40px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    padding: 14,
                    background: "#162535",
                    borderRadius: 10,
                    marginBottom: 16,
                  }}
                >
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: "50%",
                      background: detailEmp.color + "22",
                      color: detailEmp.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 18,
                      fontWeight: 700,
                      border: `2px solid ${detailEmp.color}66`,
                    }}
                  >
                    {detailEmp.av}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontFamily: "Cormorant Garamond,serif",
                        fontSize: 18,
                        fontWeight: 600,
                      }}
                    >
                      {detailEmp.prenom} {detailEmp.nom}
                    </div>

                    <div style={{ fontSize: 11, color: "#556" }}>
                      {detailEmp.poste} ? {detailEmp.dept}
                    </div>

                    <div style={{ fontSize: 10, color: "#445", marginTop: 3 }}>
                      {detailEmp.contrat} ? Depuis {detailEmp.entree}
                    </div>
                  </div>

                  <ScoreChip score={detailEmp.score} />
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                    marginBottom: 16,
                  }}
                >
                  {[
                    [
                      "Tâches jour",
                      Math.round(
                        (detailEmp.tachesDone /
                          Math.max(1, detailEmp.tachesQuot)) *
                          100,
                      ) + "%",
                    ],

                    ["Présence", detailEmp.present ? "? Présent" : "? Absent"],

                    ["Arrivée", detailEmp.arrivee],

                    ["Score", detailEmp.scoreLabel],
                  ].map(([l, v]) => (
                    <div
                      key={l}
                      style={{
                        background: "#162535",
                        borderRadius: 8,
                        padding: "10px 12px",
                        border: "1px solid rgba(255,255,255,.07)",
                      }}
                    >
                      <div
                        style={{ fontSize: 9, color: "#556", marginBottom: 3 }}
                      >
                        {l}
                      </div>

                      <div
                        style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}
                      >
                        {v}
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    fontSize: 10,
                    color: detailEmp.color,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    margin: "14px 0 8px",
                  }}
                >
                  🔹 Pointage
                </div>

                <div style={{ display: "flex", gap: 4 }}>
                  {(detailEmp.pointage || []).map((p, i) => (
                    <div
                      key={i}
                      style={{
                        flex: 1,
                        height: 24,
                        borderRadius: 3,
                        background:
                          p === "ok"
                            ? "rgba(67,160,71,.2)"
                            : p === "retard"
                              ? "rgba(251,140,0,.18)"
                              : "rgba(229,57,53,.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PtCell s={p} />
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    fontSize: 10,
                    color: detailEmp.color,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    margin: "14px 0 8px",
                  }}
                >
                  🔹 Objectifs
                </div>

                {(detailEmp.objectifs || []).length === 0 ? (
                  <div
                    style={{ fontSize: 11, color: "#445", fontStyle: "italic" }}
                  >
                    Aucun objectif.
                  </div>
                ) : (
                  (detailEmp.objectifs || []).map((o, i) => (
                    <div key={o.id || i} style={{ marginBottom: 8 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 3,
                        }}
                      >
                        <span style={{ fontSize: 10, color: "#aaa" }}>
                          {o.titre}
                        </span>

                        <span
                          style={{
                            fontSize: 10,
                            fontWeight: 600,
                            color: o.progression >= 80 ? "#66bb6a" : "#C9A84C",
                          }}
                        >
                          {o.progression}%
                        </span>
                      </div>

                      <Pbar pct={o.progression} />
                    </div>
                  ))
                )}

                <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
                  <button
                    className="btn-gold"
                    style={{ flex: 1, fontSize: 11 }}
                    onClick={() => {
                      openModal("employe", { ...detailEmp, _isEdit: true });
                      setDetailEmp(null);
                    }}
                  >
                    🔹 Modifier
                  </button>

                  <button
                    className="btn-outline"
                    style={{ fontSize: 11 }}
                    onClick={() => setDetailEmp(null)}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
}
